import { useNavigate } from 'react-router-dom';
import { useLastPageStore, useNavigationMenu } from '../lib/store/v3/layout';
import { useOpenUpUpgradeModal } from '../lib/store/frame.store';

export const useUpgradeNavigation = () => {
  const navigate = useNavigate();
  const setNavigation = useNavigationMenu((state: any) => state.setNavigation);
  const setLastPage = useLastPageStore((state) => state.setLastPage);
  const setOpenUpgradeModal = useOpenUpUpgradeModal((state: any) => state.setOpen);

  const handleUpgradeNavigation = (location: string) => {
    const getPageName = location.split('/');
    // if (getPageName[1] === 'v3') {
    setLastPage(getPageName[1]);
    setNavigation('upgrade');
    navigate('/upgrade');
    // } else {
    //   setOpenUpgradeModal(true);
    // }
  };

  return { handleUpgradeNavigation };
};
